<template>
    <div class="stake-card-component" :class="mode == 'dark' ? 'dark' : 'light'">
        <router-link :to="'/stake/' + card.id">
            <div class="uk-card uk-box-shadow-medium uk-box-shadow-hover-large uk-flex uk-flex-column uk-margin-remove-bottom">
                <div class="uk-flex uk-flex-row uk-flex-middle uk-flex-center">
                    <img class="uk-margin-small-right" :src="card.icon" alt="Crypto icon">
                    <h3 class="uk-card-title uk-margin-remove">{{ card.title }}</h3>
                </div>
                <p class="uk-text-center uk-margin-remove-bottom">Deposit: {{ card.deposit }}</p>
                <p class="uk-text-center uk-margin-remove-bottom">Earn: {{ card.earn }}</p>
                <div class="uk-flex uk-flex-center">
                    <h4 v-if="card.APY" class="uk-text-center uk-margin-top">{{ card.APY }}% APY</h4>
                    <h4 v-if="card.rewards" class="uk-text-center uk-margin-top">{{ card.rewards }} USD</h4>
                </div>
            </div>
        </router-link>
    </div>    
</template>

<script>
export default {
    name: "StakeCard",
    props: {
        mode: String,
        card: Object
    }
}
</script>

<style lang="less" scoped>
    @import "../../dark-components/stake-card.less";

    a, a:hover, a:active {
        text-decoration: none;
    }

    .uk-card {
        cursor: pointer;
        margin-top: 1em;
    }

    .uk-flex img {
        height: 48px;
    }

    h3 {
        font-family: 'Lato';
        .fluid-font(1.2, 20, 320, 3840);
        color: @text-color;
    }

    p {
        font-family: 'Lato';
        .fluid-font(1, 15, 320, 3840);
        color: @text-color;
    }

    h4 {
        padding: .5em;
        width: fit-content;
        background-image: url("../../assets/bread.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        font-family: 'Lato';
        font-weight: 700;
        .fluid-font(1, 20, 320, 3840);
        color: @text-color;
    }

</style>